// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3920":"2a4e6361","5854":"10ed34d4"}[chunkId] + ".chunk.css";
};